module.exports = __webpack_public_path__ + "img/kruemel.900bd6c2.png";